import { ReuploadReason } from '@dtos/reupload-reason';
import type { RequestStatus } from '@models/request-status';
import { IRemoteRepresentativeService } from '@services/remote-representative-service';
import {
    action,
    observable
} from 'mobx';
import {
    actionAsync,
    task
} from 'mobx-utils';

export interface IReuploadDocumentModalStore {
    readonly selectedReason: ReuploadReason | null;
    readonly showModal: boolean;
    readonly reuploadRequestStatus: RequestStatus;

    setSelectedReason(reason: ReuploadReason): void;
    initialise(): void;
    openModal(): void;
    closeModal(): void;
    requestReuploadAsync(): Promise<void>;
}

export class ReuploadDocumentsModalStore implements IReuploadDocumentModalStore {
    @observable
    selectedReason: ReuploadReason | null = null;
    @observable
    showModal: boolean = false;
    @observable
    reuploadRequestStatus: RequestStatus = 'inactive';

    constructor(
        private remoteRepresentativeService: IRemoteRepresentativeService
    ) {}

    @action.bound
    setSelectedReason(reason: ReuploadReason): void {
        this.selectedReason = reason;
    }

    @action.bound
    initialise() {
        this.selectedReason = null;
        this.showModal = false;
        this.reuploadRequestStatus = 'inactive';
    }

    @action.bound
    closeModal(): void {
        this.showModal = false;
    }

    @action.bound
    openModal(): void {
        this.showModal = true;
    }

    @actionAsync
    requestReuploadAsync = async (): Promise<void> => {
        this.reuploadRequestStatus = 'pending';

        try {
            const result = await task(this.remoteRepresentativeService.resetI9Async());
            if (!result) {
                this.reuploadRequestStatus = 'error';
                return;
            }
            this.reuploadRequestStatus = 'success';
        } catch (error) {
            this.reuploadRequestStatus = 'error';
        }
    };
}



// WEBPACK FOOTER //
// ./src/stores/modal/reupload-documents-modal-store.ts